import { Image, StyleSheet, Text, View } from "@react-pdf/renderer"
import React from 'react'
import styles from "../styles"
import Signature from '../icons/signature.jpg'

export default function CertificateFooter({ salon }: Props) {
    return (
        <View style={[ownStyles.footer, { flexShrink: 0 }]}>
            <View>
                <View style={[ownStyles.chairman]}>
                    <View style={{ height: "100px", width: "100px", marginRight: "5px" }}>
                        <Image src={Signature} style={{ height: "100px", width: "100px"}} />
                    </View>
                    <View>
                        <Text style={[styles.sm]}>Chairman</Text>
                        <Text style={[styles.p, styles.bold]}>Aleksey Anisimov</Text>
                    </View>
                </View>
            </View>
            <View>
                <View style={[ownStyles.organizations]}>
                    {salon.attrs.logos().map((logo, idx) => (
                        <View style={[styles.mgl15, ownStyles.logo]}>
                            <View key={idx} style={[{ height: "45px", width: "auto" }, styles.mgb5]}>
                                <Image src={{ uri: logo.url, body: '', headers: {}, method: 'GET' }} />
                            </View>
                            <Text style={{ fontSize: '10px' }}>{logo.patronage}</Text>
                        </View>
                    ))}
                </View>
            </View>
        </View>
    )
}

interface Props {
    salon: Customer.Models.Salon.Stateful
}

const ownStyles = StyleSheet.create({
    footer: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        marginTop: '15px',
        marginBottom: '-15px'
    },
    chairman: {
        flexDirection: "row",
        alignItems: "center"
    },
    organizations: {
        flexDirection: "row",
        justifyContent: "flex-end"
    },
    logo: {
        flexDirection: "column",
        alignItems: "center"
    }
})